import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mt-3 space-y-1.5" }
const _hoisted_2 = { class: "flex size-4 shrink-0 items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "size-3 animate-spin rounded-full border-2 border-white/30 border-t-white",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "mt-2 h-1.5 max-w-md overflow-hidden rounded-full bg-white/20" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CheckIcon } from '@heroicons/vue/24/solid';
import useLivviaStore from '@/store/livvia';


export default /*@__PURE__*/_defineComponent({
  __name: 'LivviaProcessing',
  setup(__props) {

const { t } = useI18n();
const livvia = useLivviaStore();

const steps = computed(() => [
  { key: 'read', label: t('livvia.processing.stepRead', { comments: livvia.lastLive?.commentsCount ?? 0 }) },
  { key: 'listen', label: t('livvia.processing.stepListen') },
  { key: 'build', label: t('livvia.processing.stepBuild') },
  { key: 'prepare', label: t('livvia.processing.stepPrepare') },
]);

// Row state = 'pending' | 'active' | 'done'
// processingStep counter: 0..steps.length. When counter > i, that step is done.
// When counter === i, it's active.
const rowState = (i: number): 'pending' | 'active' | 'done' => {
  const s = livvia.processingStep;
  if (s > i) return 'done';
  if (s === i) return 'active';
  return 'pending';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: step.key,
        class: _normalizeClass(["flex items-center gap-2 text-sm font-medium transition-opacity", rowState(i) === 'pending' ? 'text-white/50 opacity-60' : 'text-white opacity-100'])
      }, [
        _createElementVNode("span", _hoisted_2, [
          (rowState(i) === 'active')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : (rowState(i) === 'done')
              ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                  key: 1,
                  class: "size-4 text-emerald-300",
                  "aria-hidden": "true"
                }))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", null, _toDisplayString(step.label), 1)
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "h-full rounded-full bg-gradient-to-r from-teal-300 to-emerald-300 transition-[width] duration-500 ease-out",
        style: _normalizeStyle({ width: `${_unref(livvia).processingProgress}%` })
      }, null, 4)
    ])
  ]))
}
}

})